<template>
  <div class="main-layout">
    <!-- Sidebar -->
    <aside :class="['sidebar shadow-sm transition', sidebarOpen ? 'open' : '']">
      <!-- Logo / Nom clinique -->
      <div class="logo text-center mb-4">
        <p class="h3 nom-clinique text-gradient fw-bold">
          {{ nomClinique || "CLINIQUE" }}
        </p>
      </div>

      <nav class="p-2">
        <ul class="nav flex-column">
          <!-- Tableau de bord -->
          <li class="nav-item" v-if="$store.getters.hasPermission('DASHBOARD')">
            <router-link
              to="/"
              class="nav-link"
              exact-active-class="active-exact"
              
              @click="navigateAndClose('/')"
            >
              <i class="bi bi-house me-2"></i> Tableau de bord
            </router-link>
          </li>

          <!-- Patients -->
          <li class="nav-item" v-if="$store.getters.hasPermission('PATIENT_LIST')">
            <router-link
              to="/patients"
              class="nav-link"
            exact-active-class="active-exact"
              :class="{ active: isPatientRouteActive}"
              @click="navigateAndClose('/patients')"
            >
              <i class="bi bi-person me-2"></i> Patients
            </router-link>
          </li>

          <!-- Consultations -->
          <li class="nav-item" v-if="$store.getters.hasPermission('CONSULT_VIEW')">
            <router-link
              to="/consultations_"
              class="nav-link"
              :class="{ active: $route.path === '/consultations_' }"
              @click="navigateAndClose('/consultations_')"
            >
              <i class="bi bi-hospital me-2"></i> Consultations
            </router-link>
          </li>

          <!-- Hospitalisation 
          <li class="nav-item" v-if="$store.getters.hasPermission('HOSP_VIEW')">
            <router-link
              to="/hospitalisations"
              class="nav-link"
              exact-active-class="active-exact"
              @click="navigateAndClose('/hospitalisations')"
            >
              <i class="bi bi-clipboard-data me-2"></i> Hospitalisation
            </router-link>
          </li>-->
          <!-- Hospitalisation -->
          <li class="nav-item" v-if="$store.getters.hasPermission('HOSP_VIEW')">
            <a class="nav-link d-flex justify-content-between align-items-center"
               @click="toggleCollapse('hospitalisation')">
              <span><i class="bi bi-clipboard-data me-2"></i> Hospitalisation</span>
              <i class="bi" :class="openedCollapse==='hospitalisation'?'bi-chevron-up':'bi-chevron-down'"></i>
            </a>
            <ul v-show="openedCollapse==='hospitalisation'" class="submenu list-unstyled">
              <li  class="ms-1" v-if="$store.getters.hasPermission('HOSP_VIEW')">
                <router-link to="/hospitalisations" class="nav-link" @click="navigateAndClose('/hospitalisations')">
                  Liste des hospitalisations
                </router-link>
              </li>
               <li class="ms-1" v-if="$store.getters.hasPermission('CONFIG_CHAMBRE')">
                <router-link to="/chambres" class="nav-link" @click="navigateAndClose('/chambres')">
                  Etat des chambres
                </router-link>
              </li>
            </ul>
          </li>


          <!-- Pharmacie -->
         <!-- <li class="nav-item" v-if="$store.getters.hasPermission('VIEW_PHARMACIE')">
            <a class="nav-link d-flex justify-content-between align-items-center"
               @click="toggleCollapse('pharmacie')">
              <span><i class="bi bi-capsule me-2"></i> Pharmacie</span>
              <i class="bi" :class="openedCollapse==='pharmacie'?'bi-chevron-up':'bi-chevron-down'"></i>
            </a>
            <ul v-show="openedCollapse==='pharmacie'" class="submenu">
              <li classs="ms-1" v-if="$store.getters.hasPermission('MEDICAMENT_LIST')">
                <router-link to="/medicaments" class="nav-link" @click="navigateAndClose('/medicaments')">
                  Liste des médicaments
                </router-link>
              </li>
              <li>
                <router-link to="/retrait_medicaments" class="nav-link" @click="navigateAndClose('/retrait_medicaments')">
                  Retrait de médicaments
                </router-link>
              </li>
              <li classs="ms-1" v-if="$store.getters.hasPermission('LISTE_APPROVISIONNEMENT')" >
                <router-link to="/approvisionnements" class="nav-link" @click="navigateAndClose('/approvisionnements')">
                  Approvisionnement
                </router-link>
              </li>
            </ul>
          </li>-->
          <!-- Pharmacie -->
<li class="nav-item" v-if="$store.getters.hasPermission('VIEW_PHARMACIE')">
  <a class="nav-link d-flex justify-content-between align-items-center"
     @click="toggleCollapse('pharmacie')">
    <span><i class="bi bi-capsule me-2"></i> Pharmacie</span>
    <i class="bi" :class="openedCollapse==='pharmacie'?'bi-chevron-up':'bi-chevron-down'"></i>
  </a>

  <ul v-show="openedCollapse==='pharmacie'" class="submenu list-unstyled">

    <!-- PRODUITS -->
    <li class="ms-1" v-if="$store.getters.hasPermission('PRODUIT_LIST')">
      <router-link to="/produits" class="nav-link" @click="navigateAndClose('/produits')">
        <i class="bi bi-box-seam me-2"></i> Produits
      </router-link>
    </li>

    <!-- APPROVISIONNEMENT -->
    <li class="ms-1" v-if="$store.getters.hasPermission('LISTE_APPROVISIONNEMENT')">
      <router-link to="/approvs" class="nav-link" @click="navigateAndClose('/approvs')">
        <i class="bi bi-truck me-2"></i> Approvisionnement
      </router-link>
    </li>

    <!-- VENTE -->
    <li class="ms-1" v-if="$store.getters.hasPermission('LISTE_VENTE')">
      <router-link to="/ventes" class="nav-link" @click="navigateAndClose('/ventes')">
        <i class="bi bi-cart-check me-2"></i> Vente / Caisse
      </router-link>
    </li>

    <!-- STOCK 
    <li class="ms-1" v-if="$store.getters.hasPermission('STOCK_VIEW')">
      <router-link to="/stock" class="nav-link" @click="navigateAndClose('/stock')">
        <i class="bi bi-bar-chart me-2"></i> Stock & Mouvements
      </router-link>
    </li>
     STOCK -->
    <li class="ms-1" v-if="$store.getters.hasPermission('LOT_PRODUIT')">
  <router-link to="/stocks-lots" class="nav-link" @click="navigateAndClose('/stocks-lots')">
    <i class="bi bi-box-seam me-2"></i> Stock par lot
  </router-link>
</li>

  </ul>
</li>

          <!-- Transactions -->
          <li class="nav-item " v-if="$store.getters.hasPermission('TRANSACTION')">
            <a class="nav-link d-flex justify-content-between align-items-center"
               @click="toggleCollapse('transactions')">
              <span><i class="bi bi-folder me-2"></i> Transactions</span>
              <i class="bi" :class="openedCollapse==='transactions'?'bi-chevron-up':'bi-chevron-down'"></i>
            </a>
            <ul v-show="openedCollapse==='transactions'" class="submenu">
              <li class="ms-1" v-if="$store.getters.hasPermission('TRANS_LIST_CONSULTATION')">
                <router-link to="/paiement_consultations_" class="nav-link" @click="navigateAndClose('/paiement_consultations_')">
                  <i class="bi bi-shield-lock me-2"></i> Paiement Consultation
                </router-link>
              </li>
               <li class="ms-1" v-if="$store.getters.hasPermission('TRANS_LIST_AUTRES_SERVICES')">
                <router-link to="/paiements" class="nav-link" @click="navigateAndClose('/paiements')">
                  <i class="bi bi-shield-lock me-2"></i> Paiement
                </router-link>
              </li>
            </ul>
          </li>

          <!-- Configuration -->
          <li class="nav-item" v-if="$store.getters.hasPermission('CONFIG')">
            <a class="nav-link d-flex justify-content-between align-items-center "
               @click="toggleCollapse('configuration')">
              <span><i class="bi bi-gear me-2"></i> Configuration</span>
              <i class="bi" :class="openedCollapse==='configuration'?'bi-chevron-up':'bi-chevron-down'"></i>
            </a>
            <ul v-show="openedCollapse==='configuration'" class="submenu">
              <li class="ms-1" v-if="$store.getters.hasPermission('CONFIG_LISTE_ASSURANCE')" ><router-link to="/assurances" class="nav-link" @click="navigateAndClose('/assurances')">Assurance</router-link></li>
                            <li class="ms-1" v-if="$store.getters.hasPermission('CONFIG_LISTE_CONDITIONNEMENT')"><router-link to="/conditionnements" class="nav-link" @click="navigateAndClose('/conditionnements')">Conditionnement</router-link></li>
              <li class="ms-1" v-if="$store.getters.hasPermission('CONFIG_MOYEN_PAIEMENT')"><router-link to="/moyen_paiements" class="nav-link" @click="navigateAndClose('/moyen_paiements')">Moyen de paiement</router-link></li>
              <li class="ms-1" v-if="$store.getters.hasPermission('CONFIG_LISTE_TYPE_CONSULTATION')"><router-link to="/type_consultations" class="nav-link" @click="navigateAndClose('/type_consultations')">Type Consultation</router-link></li>
              <li class="ms-1" v-if="$store.getters.hasPermission('CONFIG_LISTE_TYPE_EXAMEN')"><router-link to="/type_examens" class="nav-link" @click="navigateAndClose('/type_examens')">Type Examen</router-link></li>
               <li class="ms-1" v-if="$store.getters.hasPermission('CONFIG_LISTE_TYPE_SERVICE')"><router-link to="/type_services" class="nav-link" @click="navigateAndClose('/type_services')">Type Service</router-link></li>
                <li class="ms-1" v-if="$store.getters.hasPermission('CONFIG_LISTE_SERVICE')"><router-link to="/services" class="nav-link" @click="navigateAndClose('/services')">Services</router-link></li>
              <li class="ms-1" v-if="$store.getters.hasPermission('CONFIG_LISTE_FREQUENCE')"><router-link to="/frequences" class="nav-link" @click="navigateAndClose('/frequences')">Posologie</router-link></li>
              <li class="ms-1" v-if="$store.getters.hasPermission('CONFIG_LISTE_DUREE_MEDICAMENT')"><router-link to="/duree_medicaments" class="nav-link" @click="navigateAndClose('/duree_medicaments')">Durée Médicament</router-link></li>
              <li class="ms-1" v-if="$store.getters.hasPermission('CONFIG_TYPE_HOSPITALISATION')"><router-link to="/type_hospitalisations" class="nav-link" @click="navigateAndClose('/type_hospitalisations')"> Types Hospitalisations</router-link></li>
              <li class="ms-1" v-if="$store.getters.hasPermission('CONFIG_TYPE_CHAMBRE')"><router-link to="/type_chambres" class="nav-link" @click="navigateAndClose('/type_chambres')"> Types Chambres</router-link></li>
              <li class="ms-1" v-if="$store.getters.hasPermission('CONFIG_LIT')"><router-link to="/lits" class="nav-link" @click="navigateAndClose('/lits')"><i class="bi bi-bed me-2"></i> Lits</router-link></li>
            </ul>
          </li>

          <!-- Administration -->
          <li class="nav-item"  v-if="$store.getters.hasPermission('ADMIN')">
            <a class="nav-link d-flex justify-content-between align-items-center"
               @click="toggleCollapse('administration')">
              <span><i class="bi bi-folder me-2"></i> Administration</span>
              <i class="bi" :class="openedCollapse==='administration'?'bi-chevron-up':'bi-chevron-down'"></i>
            </a>
            <ul v-show="openedCollapse==='administration'" class="submenu">
              <li classs="ms-1" v-if="$store.getters.hasPermission('VIEW_CONFIGURATION_SYSTEME')">
                <router-link to="/configurations" class="nav-link" @click="navigateAndClose('/configurations')"><i class="bi bi-shield-lock me-2">
              </i> Configuration système</router-link></li>
              <li class="ms-1" v-if="$store.getters.hasPermission('ADMIN_LISTE_ROLE')">
                <router-link to="/roles" class="nav-link" @click="navigateAndClose('/roles')">
                  <i class="bi bi-shield-lock me-2"></i> Rôles</router-link>
                </li>
              <li classs="ms-1" v-if="$store.getters.hasPermission('ADMIN_LISTE_UTILISATEUR')">
                <router-link to="/utilisateurs" class="nav-link" @click="navigateAndClose('/utilisateurs')">
                  <i class="bi bi-people me-2"></i> Utilisateurs</router-link></li>
            </ul>
          </li>
        </ul>
      </nav>
    </aside>

    <!-- Overlay mobile -->
    <div v-if="sidebarOpen" class="overlay d-md-none" @click="toggleSidebar"></div>

    <!-- Contenu principal -->
    <section class="content">
      <header class="header d-flex align-items-center justify-content-between px-3">
        <!-- Bouton sidebar mobile -->
        <button class="btn btn-outline-secondary d-md-none me-3" @click="toggleSidebar">
          <i class="bi bi-list"></i>
        </button>

        <!-- Slogan / description de la clinique -->
        <div class="slogan d-flex flex-column justify-content-center">
          <h5 class="mb-0 text-primary fw-bold">
            <!--{{ configuration?.description  }}-->
          </h5>
          <small class="text-muted">
            <!--{{ configuration?.adresse ? "Adresse : " + configuration.adresse : "" }}-->
          </small>
        </div>

        <!-- Profil utilisateur --->
        <div class="dropdown">
          <button class="btn btn-light rounded-pill shadow-sm dropdown-toggle d-flex align-items-center"
                  type="button" id="userDropdown" data-bs-toggle="dropdown">
            <img :src="user?.photo || 'https://cdn-icons-png.flaticon.com/512/3774/3774299.png'"
                 class="rounded-circle me-2" style="width:40px;height:40px">
            <span v-if="currentUser">{{ currentUser.nom }} {{ currentUser.prenom }}</span>
          </button>
          <ul class="dropdown-menu dropdown-menu-end">
            <li>
               <router-link class="dropdown-item" :to="{ name: 'compte' }">
                 <i class="bi bi-person-circle me-2"></i> Mon compte
               </router-link>
            </li>
            <li><a class="dropdown-item" href="#">Paramètres</a></li>
            <li><hr class="dropdown-divider"></li>
            <li><a class="dropdown-item text-danger" href="#" @click="logout"><i class="bi bi-box-arrow-right me-1"></i> Déconnexion</a></li>
          </ul>
        </div>
      </header>

      <main>
        <router-view />
      </main>
    </section>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "MainLayout",
  data() {
    return {
      sidebarOpen: false,
      openedCollapse: null,
      selectedEntite: null,
      user: null,
      nomClinique: null
    };
  },
  computed: {
     isPatientRouteActive() {
    
    const patientRoutes = [
      'patients',               
      'information_personnelle', 
      'edit_patient',  
      'create_patient',        
      'consultations_patient',  
      'hospitalisations_patient', 
      'ordonnances_patient',
      'factures_patient',
      'analyses_patient',
      'details_hospitalisation',
      'traitement_consultation',
      'services_patient'
    ];

    return patientRoutes.includes(this.$route.name);
  },
    currentUser() {
      //console.log(this.$store.getters.hasPermission('DASHBOARD'));
      
      return this.$store.getters.user;

    },
    hasRole() {
    return this.$store.getters.hasRole;
    },
  hasAnyRole() {
    return this.$store.getters.hasAnyRole;
  }
  },
  async created() {
    await this.fetchNomClinique();
  },
  methods: {
 async fetchNomClinique() {
  try {
    const res = await api.getItems("configurations/entete");
    this.nomClinique = res.data.nom;
    this.configuration = res.data;
  } catch (e) {
    console.error("Erreur récupération configuration", e);
    this.nomClinique = "CLINIQUE";
  }
},
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },
    toggleCollapse(name) {
      this.openedCollapse = this.openedCollapse === name ? null : name;
    },
    navigateAndClose(link) {
      if (window.innerWidth < 768) {
        this.sidebarOpen = false;
        this.openedCollapse = null;
        setTimeout(() => this.$router.push(link), 200);
      } else {
        this.$router.push(link);
      }
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    }
  }
};
</script>

<style scoped>
.main-layout {
  display: flex;
  min-height: 100vh;
 background: #f8fafd;
  /*overflow: hidden;*/
}

/* Sidebar */
.sidebar {
   width: 280px;
  background: #fff;
  padding: 1rem;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  overflow-y: auto;
  border-radius: 16px 0 0 16px;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, width 0.3s ease;
  z-index: 1030;
}
@media(max-width:767px) {
  .sidebar { transform: translateX(-100%); }
  .sidebar.open { transform
: translateX(0); }
}

/* Liens sidebar */
.sidebar .nav-link {
  color: #1565c0;
  margin-bottom: 6px;
  border-radius: 10px;
  padding: 10px 12px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
}
.sidebar .nav-link.active {
background: linear-gradient(90deg,#0d6efd,#6610f2);
color: #fff !important;
font-weight: 600;
}

.submenu { padding-left: 15px; margin-top: 5px; }
.submenu .nav-link { font-size: 0.92rem; }

/* Overlay pour mobile */
.overlay {
position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.4);
  z-index: 1020;
}

/* Contenu principal */
.content {
  flex: 1;
  margin-left: 280px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  transition: margin-left 0.3s ease;
}
@media (max-width: 767px) {
  .content {
    margin-left: 0;
  }
}

.header {
height: 70px;
  background: #fff;
  border-bottom: 1px solid #e3f2fd;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  z-index: 1040;
  flex-shrink: 0;
}

.header .slogan h5 {
font-size: 1.1rem;
color: #0d6efd;
font-weight: 600;
}

.header .slogan small {
font-size: 0.8rem;
color: #6c757d;
}

main {
flex: 1;
overflow-y: auto;
padding: 1rem;
}

.nom-clinique {
background: linear-gradient(90deg, #0d6efd, #6610f2);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
transition: all 0.3s ease;
cursor: default;
}
.nom-clinique:hover {
transform: scale(1.05);
text-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* Sous-menu mobile */
.submenu {
transition: max-height 0.3s ease;
overflow: hidden;
}
.sidebar .nav-link.active-exact {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  color: #fff !important;
  font-weight: 600;
  border-radius: 10px;
}

/* Active link du sous-menu */
.submenu .router-link-active,
.submenu .router-link-exact-active {
  background: rgba(13, 110, 253, 0.1);
  border-left: 3px solid #0d6efd;
  color: #0d6efd !important;
  font-weight: 600;
  border-radius: 8px;
}

</style>